export default __webpack_public_path__ + "static/media/iconoTienda2.e6f4c823.svg";